import React, { useState } from 'react';
import HttpsIcon from './HttpsIcon';
import DotGovIcon from './DotGovIcon';
import UsFlagLogo from './UsFlagLogo';

/**
 * This is a static react port of the cdc template 4.5 gov notice
 */

const OfficialNotice = () => {

    const [showBody, setShowBody] = useState(false);

    const toggleBody = () => {
        setShowBody(!showBody);
    };

    return (
        <div className="cdc-header-official-notice container" role="alert" aria-label="Government Notice" aria-live="assertive">
            <div className="cdc-header-official-notice-header d-flex">
                <UsFlagLogo  width="16" height="11" alt="U.S. flag" />
                <small className="ml-2">An official website of the United States government.
                    <button className="cdc-header-official-notice-header-btn" onClick={toggleBody}>Here&apos;s how you know
                        <span className="cdc-header-official-notice-header-icon x12 fill-p cdc-icon-arrow-down"></span>
                    </button></small>
            </div>
            {showBody && (
                <div className="cdc-header-official-notice-body row">
                    <figure className="col-lg-6 d-flex">
                        <DotGovIcon className="cdc-header-official-notice-body-img" alt="Official icon" aria-hidden="true" height="30" width="30" />
                        <figcaption className="cdc-header-official-notice-body-info ml-3">
                            <p className="cdc-header-official-notice-body-title mb-1"><strong>Official websites use .gov</strong></p>
                            <p>A .gov website belongs to an official government organization in the United States.</p>
                        </figcaption>
                    </figure>
                    <figure className="col-lg-6 d-flex">
                        <HttpsIcon className="cdc-header-official-notice-body-img" alt="Official icon" aria-hidden="true" height="30" width="30" />
                        <figcaption className="cdc-header-official-notice-body-info ml-3">
                            <p className="cdc-header-official-notice-body-title mb-1"><strong>Secure .gov websites use HTTPS</strong></p>
                            <p>A lock ( <span className="x16 fill-black cdc-icon-lock-alt-solid"></span> ) 

                            or https:// means you&apos;ve safely connected to the .gov website. Share sensitive information only on
                             official, secure websites.</p>
                        </figcaption>
                    </figure>
                </div>
            )}
        </div>
    )
}

export default OfficialNotice;